import { render, staticRenderFns } from "./EdateCard.vue?vue&type=template&id=383ab594&scoped=true&"
import script from "./EdateCard.vue?vue&type=script&lang=js&"
export * from "./EdateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ab594",
  null
  
)

export default component.exports